const INITIAL_STATE = {
  maquinaList: [],
  maquina: null
  }
  
  export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case 'MAQUINALIST_FETCH':
        return { ...state, maquinaList: action.payload }
      case 'MAQUINA_SET':
        return { ...state, maquina: action.payload }
      default:
        return state
    }
  }